import { IOrgHandle } from "@novel/shared/interfaces/OrgHandle";
import {
    HOST_WITH_CORRECTED_SUBDOMAINS,
    customerPassPrefix,
} from "@novel/shared/utils/appConstants";

export function getPassLinkForHandle(orgHandle: IOrgHandle): string {
    return `https://${orgHandle.handle}.${HOST_WITH_CORRECTED_SUBDOMAINS}${customerPassPrefix}`;
}
